// ─────────────────────────────────────────────
//  App Configuration
//  Runtime values come from window._env_ which
//  is written by docker-entrypoint.sh at startup.
//  Hardcoded values below are fallbacks for
//  local development only (npm start).
// ─────────────────────────────────────────────

let env = {};
let envsLocal = {
  REACT_APP_WS_BASE_HOST: process.env.REACT_APP_WS_BASE_HOST,
};
const getEnv = () => {
    if (process.env.NODE_ENV === "development") {
        return (env = envsLocal);
    } else {
        return (env = window._env_);
    }
};

getEnv();


// ── WebSocket / API ──────────────────────────
// org_code is the first path segment: https://businesses.akunah.ai/<org_code>
export const ORG_CODE = window.location.pathname.split('/').filter(Boolean)[0] || null;


const WS_BASE_HOST = env.REACT_APP_WS_BASE_HOST || '';
export const WS_URL = ORG_CODE && WS_BASE_HOST
  ? `${WS_BASE_HOST}/api/v1/clarity/clarity_socket/chatbot-ws-stream?org_code=${ORG_CODE}`
  : null;

// ── Logos ────────────────────────────────────
export const LOGOS = {
  logo: '/logos/logo.png',
};

// ── UI copy ──────────────────────────────────
export const INPUT_PLACEHOLDER = 'Message clarity…';
export const DISCLAIMER =
  env.DISCLAIMER || 'clarity may produce errors — always verify with current clinical guidelines';
